import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";

export const isIncludingReadOnlyAccounts = (
  resources?: (AllTypeResourceItem | undefined)[],
) => {
  if (!resources) {
    return;
  }

  return resources.some((resource) => {
    if (!resource) {
      return true;
    }

    if (isResourceKubernetes(resource)) {
      return true;
    } else {
      return resource?.account?.provider_access_type === "read";
    }
  });
};
